import clsx from 'clsx';
import { Chip } from 'copilot-design-system';

import { MultiSelectOption } from 'src/legacy/components/Select/types';
import { isCategoricalColor } from 'src/utils/ColorUtils';

export const OptionColorDisplay = ({
  color,
  className,
}: {
  color: MultiSelectOption['color'];
  className?: string;
}) => {
  return (
    <div
      className={className}
      style={{
        // categorical colors are defined as css variables in the theme
        // legacy colors should be passed as strings
        backgroundColor: isCategoricalColor(color)
          ? `var(--${color}-primary)`
          : color,
      }}
    />
  );
};

export const OptionChip = ({
  label,
  color,
  className,
  onClose,
}: {
  label: string;
  color: MultiSelectOption['color'];
  className?: string;
  onClose?: () => void;
}) => {
  return (
    <Chip
      className={clsx('cursor-pointer', className, 'option-chip')}
      label={label}
      variant="outlined"
      prefixIcon={
        color === 'none' ? null : (
          <OptionColorDisplay color={color} className="w-2 h-2 rounded-full" />
        )
      }
      onClose={onClose}
    />
  );
};
